import {
	ADMIN_TENANT_METADATA,
	IAdminTenantMetadata
}                           from '@app/modules/admin-tenant/config/admin-tenant.config';
import { TenantStatusEnum } from '@app/modules/admin-tenant/models/tenant.model';
import {
	FilterIdentifiersEnum,
	FilterTypes
}                           from '@shared/list-operations/model/filter.model';

// tslint:disable-next-line:no-empty-interface
export interface IResellerTenantMetadata extends IAdminTenantMetadata {}


export const RESELLER_TENANT_METADATA: IResellerTenantMetadata = {
	...ADMIN_TENANT_METADATA,
	listOperations: {
		id: ADMIN_TENANT_METADATA.listOperations?.id,
		pagingData: { ...ADMIN_TENANT_METADATA.listOperations.pagingData },
		searchData: { ...ADMIN_TENANT_METADATA.listOperations.searchData },
		sortData: [ ...ADMIN_TENANT_METADATA.listOperations.sortData ],
		filterData: [
			{
				order: 1,
				isRendered: true,
				isDisabled: false,
				filterId: FilterIdentifiersEnum.FILTER,
				type: FilterTypes.FILTER_TEXT_TYPE,
				i18nPath: 'tenant.filter.queryFilter',
				items: [
					{ i18nPath: 'tenant.filter.queryFilter' }
				]
			},
			{
				order: 2,
				isRendered: true,
				isDisabled: false,
				filterId: FilterIdentifiersEnum.STATUS,
				type: FilterTypes.FILTER_LIST_TYPE,
				i18nPath: 'shared.forms.status',
				values: [ TenantStatusEnum.ACTIVE ],
				items: [
					{ value: TenantStatusEnum.ACTIVE, i18nPath: 'shared.status.active' },
					{ value: TenantStatusEnum.DISABLED, i18nPath: 'shared.status.disabled' }
				]
			}
			// TODO check why it was removed from api and if it needs to be restored in api or removed here
			// {
			// 	order: 3,
			// 	isRendered: true,
			// 	isDisabled: false,
			// 	filterId: FilterIdentifiersEnum.TYPE,
			// 	type: FilterTypes.FILTER_OPTION_TYPE,
			// 	i18nPath: 'tenant.filter.type',
			// 	items: [
			// 		{ value: TenantTypeEnum.MANAGED, i18nPath: 'tenant.type.managed' },
			// 		{ value: TenantTypeEnum.STANDARD, i18nPath: 'tenant.type.standard' },
			// 		{ value: TenantTypeEnum.TEST, i18nPath: 'tenant.type.test' }
			// 	]
			// }
		]
	},
	status: { ...ADMIN_TENANT_METADATA.status }
};
